































import Vue from 'vue'
interface Data {
  passwordRevealed: boolean
}
export default Vue.extend({
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'current-password'
    },
    name: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data(): Data {
    return {
      passwordRevealed: false
    }
  },
  methods: {
    revealPassword() {
      this.passwordRevealed = !this.passwordRevealed
      const passwordInput = this.$refs.passwordInput
      passwordInput && passwordInput.focus(true)
    }
  }
})
